import React, { FC, useState, useEffect, useCallback, useMemo } from 'react'

import { BodyComponent } from './Body';
import ThemeContext, { themes } from '@/theme/context'
import { Calltoaction } from '@/components/Calltoaction';
import { Slider } from '@/components/Slider';

export const FepoPro = (props) => {
    return (
        <ThemeContext.Provider value={themes.fepo_pro}>
            <Slider
                background='/themes/defaultNiimko/images/fepo_pro/slider.svg'
                header='Оценка качества образования студентов в&nbsp;конце второго курса в&nbsp;форме сертификационного экзамена'
            />
            <BodyComponent {...props}/>
            <Calltoaction {...props} />
        </ThemeContext.Provider>
    )
}